export enum WorkspaceProvisionStatusType {
    Accepted = "Accepted",
    Canceled = "Canceled",
    Created = "Created",
    Creating = "Creating",
    Deleted = "Deleted",
    Deleting = "Deleting",
    Failed = "Failed",
    Ready = "Ready",
    Running = "Running",
    Succeeded = "Succeeded",
    Updating = "Updating",
    Unknown = "Unknown"
}

export const WorkspaceCreatingStates: WorkspaceProvisionStatusType[] = [
    WorkspaceProvisionStatusType.Accepted,
    WorkspaceProvisionStatusType.Creating,
    WorkspaceProvisionStatusType.Updating,
    WorkspaceProvisionStatusType.Deleting
];

export const WorkspaceFailureStates: WorkspaceProvisionStatusType[] = [
    WorkspaceProvisionStatusType.Canceled,
    WorkspaceProvisionStatusType.Deleted,
    WorkspaceProvisionStatusType.Failed
];

export const WorkspaceSuccessStates: WorkspaceProvisionStatusType[] = [
    WorkspaceProvisionStatusType.Created,
    WorkspaceProvisionStatusType.Ready,
    WorkspaceProvisionStatusType.Running,
    WorkspaceProvisionStatusType.Succeeded
];